module.exports = __webpack_public_path__ + "img/jppdimg_mo1.32559e7d.png";